import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, NavLinkProps } from "react-router-dom";
import tw from "twin.macro";

import { SvgIconType } from "@/types/shared";

export type MainNavigationLinkProps = NavLinkProps & {
  label?: string;
  icon?: SvgIconType;
  onClick?: () => void;
};

const MainNavigationLink = ({
  to,
  label,
  icon: Icon,
  onClick,
  ...props
}: MainNavigationLinkProps) => {
  const { t } = useTranslation();
  return (
    <NavLink
      to={to}
      end
      className="group"
      tw="transition flex gap-x-3  items-center rounded-b-xl rounded-tl-xl px-4 py-2.5 leading-6 font-semibold hover:(text-gray-900  bg-white dark:text-white) focus:(outline-none ring-2 ring-offset-2 ring-primary-700/50) [&.active]:(bg-white text-gray-900 dark:text-white)"
      onClick={() => onClick?.()}
      {...props}
    >
      {({ isActive }) => (
        <Fragment>
          {Icon && (
            <Icon
              aria-hidden="true"
              strokeLinecap="round"
              css={[
                tw`h-6 w-6 shrink-0 stroke-1.5`,
                isActive
                  ? tw`text-gray-900 dark:text-primary-700 stroke-2`
                  : tw`text-white group-hover:(text-gray-900 dark:text-primary-700)`,
              ]}
            />
          )}

          {label
            ? // @ts-expect-error - string interpolation error
              t(`navigation.${label}`)
            : null}
        </Fragment>
      )}
    </NavLink>
  );
};

export default MainNavigationLink;
